import { render } from "./DogParents.vue?vue&type=template&id=4aadc26b&scoped=true"
import script from "./DogParents.vue?vue&type=script&lang=js"
export * from "./DogParents.vue?vue&type=script&lang=js"

import "./DogParents.vue?vue&type=style&index=0&id=4aadc26b&scoped=true&lang=css"

import exportComponent from "/Users/jessicabohland/Documents/Code/Website/gonsbachtal-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aadc26b"]])

export default __exports__